module.exports = __webpack_public_path__ + "img/newsListD1.6274ffb0.png";